$(document).ready(function() {
	if(!document.getElementById('resourceMonitorForm')) return false;

	var resourceMonitorForm = {
		form: document.getElementById('resourceMonitorForm'),
		category: document.getElementById('monitorCategory'),
		model : document.getElementById('monitorModel'),
		list : document.getElementById('downloadResourceList'),
		noResult : document.getElementById('noResult'),
		
		

		categoryChange: function(e) {
			var self = this;
			var	url = self.category.options[self.category.selectedIndex].getAttribute('data-url');
			
			$.ajax({
				type: 'get',
				url: url,
				dataType: 'json',
				success: function(data) {
					var optionHtml = "";
					for (var key in data) {
						if (data.hasOwnProperty(key)) {
							optionHtml += "<option value='"+ key +"'>"+ data[key] +"</option>";
						}
					}
					$(resourceMonitorForm.model).find("option:not([disabled])").remove();
					$(resourceMonitorForm.model).append(optionHtml).prop('disabled', false).trigger('chosen:updated');
				},
				error: function(request, status, error) {
				}
			});
		},

		beforeSubmit: function() {
			var self = this;
			var $form = $(self.form);

			if ($form.checkValidation()) {
				var url = $form.attr('data-url');
				var param = $form.serialize();
				
				$.ajax({
					type: 'post',
					url: url,
					data: param,
					dataType: 'html',
					success: function(data) {
						$(resourceMonitorForm.list).html('').append(data);
						$(resourceMonitorForm.list).find('.filelist a').attr('download','');
						$(resourceMonitorForm.list).show();
						$(resourceMonitorForm.noResult).hide();
					},
					error: function(request, status, error) {
					}
				});
			}
		},
		
		addEvent: function() {
			var self = this;

			$(self.category).on('change', $.proxy(self.categoryChange, self));
			$(self.form).on('click', '#monitorSubmit', function(){
				resourceMonitorForm.beforeSubmit();
			});
		},

		init: function(){
			var self = this;

			chosenScrollInit();
			self.addEvent();
		}
	};
	resourceMonitorForm.init();
});